/**
 * Admin auth helper.
 * Token stored in localStorage. All admin API calls use `adminFetch`.
 */

const API_BASE = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = 'sm_admin_token';

export function getAdminToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setAdminToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

export function isAdminAuthenticated() {
  return !!getAdminToken();
}

export function logoutAdmin() {
  setAdminToken(null);
}

export async function adminLogin(email, password) {
  const res = await fetch(`${API_BASE}/api/admin/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password }),
  });
  const data = await res.json();
  if (!res.ok) {
    throw new Error(data?.detail || 'Credenciales inválidas');
  }
  setAdminToken(data.token);
  return data;
}

export async function adminMe() {
  const token = getAdminToken();
  if (!token) throw new Error('No token');
  const res = await fetch(`${API_BASE}/api/admin/me`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) {
    setAdminToken(null);
    throw new Error('Session expired');
  }
  return res.json();
}

export async function adminFetch(path, options = {}) {
  const token = getAdminToken();
  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
  const res = await fetch(`${API_BASE}${path}`, { ...options, headers });
  if (res.status === 401) {
    setAdminToken(null);
    window.location.href = '/admin/login';
    return null;
  }
  return res;
}

/* ---------- Lots API ---------- */
export async function fetchLotsAdmin() {
  const res = await adminFetch('/api/lots/admin');
  if (!res || !res.ok) throw new Error('Failed to fetch lots');
  return res.json();
}

export async function publishLots(pins) {
  // Strategy: PATCH each lot one by one to update changes.
  // For first publish from a fresh DB we may need to upsert via POST.
  // Simplest robust approach: clear & re-create via /admin/replace-all endpoint.
  const token = getAdminToken();
  const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/lots/admin/replace-all`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ lots: pins }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err?.detail || 'Failed to publish');
  }
  return res.json();
}
